import { lazy } from 'react';

const LoginPage = lazy(() => import('./pages/LoginPage'));

export const LoginEntry = () => <LoginPage />;
